import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { RequireAuth } from './auth/RequireAuth';
import { AppShell } from './components/shell/AppShell';
import { LoginPage } from './routes/LoginPage';
import { DashboardPage } from './routes/DashboardPage';
import { FieldPage } from './routes/FieldPage';
import { JobDetailPage } from './routes/JobDetailPage';
import { WorkerRosterPage } from './routes/WorkerRosterPage';
import { CustomersPage } from './routes/CustomersPage';
import { CustomerDetailPage } from './routes/CustomerDetailPage';
import { JobsPage } from './routes/JobsPage';
import { EstimatesPage } from './routes/EstimatesPage';
import { PriceBookPage } from './routes/PriceBookPage';
import { EstimateBuilderPage } from './routes/EstimateBuilderPage';
import { SchedulePage } from './routes/SchedulePage';
import { BillingPage } from './routes/BillingPage';
import { TeamPage } from './routes/TeamPage';
import { ActivityLogPage } from './routes/ActivityLogPage';
import { PerformancePage } from './routes/PerformancePage';
import { DocumentsPage } from './routes/DocumentsPage';
import { ProfitDashboardPage } from './routes/ProfitDashboardPage';
import { PresentationsPage } from './routes/PresentationsPage';
import { PresentationBuilderPage } from './routes/PresentationBuilderPage';
import { PlaceholderPage } from './routes/PlaceholderPage';

// Real client-side routes — the URL changes with navigation, refresh and
// bookmarking work, and employees never see script.google.com. See the v6
// architecture doc §5 for the full route list this mirrors.
export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <AppShell>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/customers" element={<CustomersPage />} />
                  <Route path="/customers/:customerId" element={<CustomerDetailPage />} />
                  <Route path="/jobs" element={<JobsPage />} />
                  <Route path="/jobs/:jobId" element={<JobDetailPage />} />
                  <Route path="/estimates" element={<EstimatesPage />} />
                  <Route path="/estimates/price-book" element={<PriceBookPage />} />
                  <Route path="/estimates/builder" element={<EstimateBuilderPage />} />
                  <Route path="/estimates/:jobId" element={<JobDetailPage />} />
                  <Route path="/schedule" element={<SchedulePage />} />
                  <Route path="/billing" element={<BillingPage />} />
                  <Route path="/field" element={<FieldPage />} />
                  <Route path="/field/roster" element={<WorkerRosterPage />} />
                  <Route path="/field/:jobId" element={<JobDetailPage />} />
                  <Route path="/settings/team" element={<TeamPage />} />
                  <Route path="/settings/activity" element={<ActivityLogPage />} />
                  <Route path="/performance" element={<PerformancePage />} />
                  <Route path="/documents" element={<DocumentsPage />} />
                  <Route path="/settings/profit" element={<ProfitDashboardPage />} />
                  <Route path="/presentations" element={<PresentationsPage />} />
                  <Route path="/presentations/builder" element={<PresentationBuilderPage />} />
                  <Route path="*" element={<PlaceholderPage title="Not found" stage="—" />} />
                </Routes>
              </AppShell>
            </RequireAuth>
          }
        />
      </Routes>
    </AuthProvider>
  );
}
